/**
 * 導入後推移：列順（field code の配列）を、表示項目に合わせて絞りつつ SIS 列だけは残す純関数。
 *
 * 【Why】
 * 1. 画面上の列は「Redux に保存した列の並び（code の配列）」に載っているものだけが出る仕組み。
 * 2. PR #3604 で、その配列を「いま選んでいる表示項目（transitiveFields / nonTransitiveFields）」に合わせて短くした。
 * 3. ところが DK-SIS などで API が足す列（`isSisField`）は、表示項目のチェックには出てこないので検索条件にも入らない。
 * 4. そのまま 2. だけをやると、SIS 列の code が配列から除かれ、1. の結果としてテーブルからも消えてしまう。
 * 5. だから「表示項目として選んだ code」と「API が付けた SIS 列の code」の両方を配列に残す必要がある。
 *
 * 【What】
 * - `orderedFieldCodes` を、`userSelectedFieldCodeSet` か `sisFieldCodeSet` に含まれる code だけに filter する。
 * - 推移側でユーザー選択が空（Set が空）のときは絞り込まずそのまま返す（従来挙動）。
 *
 * 【Where】`changeColumnsOrderSaga`（データ取得成功のたび・初回表示含む）。
 * スコープは本ファイル名どおり導入後推移用（他画面では使わない想定）。
 *
 * @param orderedFieldCodes API の `columnsFor*` を並べ替えたあとの code 順
 * @param userSelectedFieldCodeSet 検索条件上の表示項目（推移・非推移の選択 code 等）
 * @param sisFieldCodeSet 同一レスポンスの列定義から集めた `isSisField` 列の code
 * @returns Redux に保存する列順 code 配列の候補
 */
export const filterOrderedColumnCodesByDisplaySelectionPreservingSis = (
  orderedFieldCodes: string[],
  userSelectedFieldCodeSet: Set<string>,
  sisFieldCodeSet: Set<string>
): string[] => {
  // 表示項目未選択扱いでは列順を触らない（全列の並びを維持）
  if (userSelectedFieldCodeSet.size === 0) {
    return orderedFieldCodes;
  }
  return orderedFieldCodes.filter(
    (fieldCode) =>
      userSelectedFieldCodeSet.has(fieldCode) || sisFieldCodeSet.has(fieldCode)
  );
};
